import React from 'react';
import { Link } from 'gatsby';

import { SearchSvg } from '../../common/svg';

import ShopSearchDrawer from '../../search/shop-search-drawer';

import '../../../styles/shop/product-view-breadcrumbs.scss';

const categoryLink = (productCategory) => {
  switch (productCategory) {
    case "Prints":
      return (
        <Link to="/shop/fine-art-prints">Fine Art Prints</Link>
      );
    case "Books":
      return (
        <Link to="/shop/pdr-press-books">PDR Press Books</Link>
      );
    default:
      return (
        <Link to="/shop/t-shirts-mugs">T-Shirts, Mugs & Totes</Link>
      );
  }
};

export default class ProductViewBreadcrumbs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchExpanded: false,
    };

    this.searchFieldRef = React.createRef();
  }

  render() {
    return (
      <>
        <div
          className={ `product-view-breadcrumbs ${this.props.addTopMargin ? 'with-top-margin' : ''}` }
        >
          <div className="product-view-breadcrumbs__row">
            {this.props.productCategory !== 'Prints' && (
              <div>
                <button
                  onClick={() => {
                    if (!this.state.searchExpanded) {
                      this.setState({ searchExpanded: true });
                      setTimeout(this.searchFieldRef.current.focus(), 100);
                    } else {
                      this.setState({ searchExpanded: false });
                    }
                  }}
                  className="search-launcher"
                >
                  { SearchSvg } Search the Shop
                </button>
              </div>
            )}
            <div>
              Browsing:{' '}
              <Link to="/shop">Shop</Link> /{' '}
              {categoryLink(this.props.productCategory)} /{' '}
              {this.props.productData.Name.replace(/<span[\S\s]+?>/g,'').replace('</span>','')}
            </div>
          </div>
        </div>
        <ShopSearchDrawer
          expanded={ this.state.searchExpanded }
          searchFieldRef={this.searchFieldRef}
        />
      </>
    );
  }
}
